export default [
  {
    path: '/companies',
    name: 'Companies',
    component: () => import('Support/layout/CrudListTemplate.vue'),
    meta: {
      itemActive: 'Companies',
      crud: {
        pageTitle: 'app.companies.title',
        btnText: 'app.companies.add',
        newRouteName: 'CompanyNew',
        pageContent: () => import('App/companies/CompaniesCrudList.vue'),
        filterComponent: () => import('Support/components/crud/OnlySearchFilter.vue'),
      },
    },
  },
  {
    path: '/companies/new',
    name: 'CompanyNew',
    component: () => import('App/companies/CompaniesForm.vue'),
    meta: {
      itemActive: 'Companies',
    },
  },
  {
    path: '/companies/:id',
    name: 'CompaniesForm',
    component: () => import('App/companies/CompaniesForm.vue'),
    meta: {
      itemActive: 'Companies',
    },
  },
];
